<section class="not-found" [class.not-found--admin]="isAdminRoute">
  <div class="not-found__content">
    <img
      class="not-found__image"
      [src]="imageSrc"
      alt="Página não encontrada"
    />

    <div class="not-found__copy">
      <h1 class="not-found__title">Página não encontrada</h1>

      <p class="not-found__description">
        @if (isAdminRoute) {
          A rota administrativa que você tentou acessar não existe ou não está
          mais disponível.
        } @else {
          A página que você tentou acessar não existe ou foi movida.
        }
      </p>
    </div>

    <button
      type="button"
      class="not-found__action"
      (click)="goToSafeRoute()"
    >
      {{ isAdminRoute ? 'Ir para o dashboard' : 'Voltar ao cardápio' }}
    </button>
  </div>
</section>